
import { Layout } from "../../components";
import { ConfirmationStatementsController } from "../../controllers";
import { Helmet } from "react-helmet-async";

class  ConfirmationStatements extends ConfirmationStatementsController {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { 
    } = this.state;
        return (
      <Layout title=" تایید اظهارات ">
        <Helmet>
          <title>  تایید اظهارات /  بیمه زندگی هامرز</title>
        </Helmet>
       
      </Layout>
    )
  }
}
export default  ConfirmationStatements;